module.exports = __webpack_public_path__ + "img/d2dd03f1dc8747f8b0aa004bb459638e-1024.7a50a591.png";